import { render, staticRenderFns } from "./VehiclesData.vue?vue&type=template&id=70610c7c&"
import script from "./VehiclesData.vue?vue&type=script&lang=js&"
export * from "./VehiclesData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports